/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_My_ServicesInputs */

const en_dashboard_my_services = /** @type {(inputs: Dashboard_My_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My services`)
};

const fr_dashboard_my_services = /** @type {(inputs: Dashboard_My_ServicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mes services`)
};

/**
* | output |
* | --- |
* | "My services" |
*
* @param {Dashboard_My_ServicesInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const dashboard_my_services = /** @type {((inputs?: Dashboard_My_ServicesInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_My_ServicesInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_my_services(inputs)
	return fr_dashboard_my_services(inputs)
});